import { render } from "./NewDocument.vue?vue&type=template&id=283f0299&scoped=true&ts=true"
import script from "./NewDocument.vue?vue&type=script&lang=ts"
export * from "./NewDocument.vue?vue&type=script&lang=ts"

import "./NewDocument.vue?vue&type=style&index=0&id=283f0299&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283f0299"]])

export default __exports__